export default {
  'order.FailedToGetPaymentLink': '獲取支付鏈接失敗',
  'order.DidntGetPaymentToken': '沒獲取到支付token',
  'order.TheSystemIsDesertedPleasePayAgain': '系統開小差啦，請重新支付',
  'order.FailedToCreateAlipayPrepaidOrder': '創建支付寶預付單失敗!',
  'order.FailedToGetPaymentInformation': '獲取支付信息失敗',
  'order.MallCashierPagepaymentMethod': '商城收銀台頁_支付方式',
  'order.MallCashierPageorderButton': '商城收銀台頁_下單按鈕',
  'order.return': '返回',
  'order.agreeAndContinue': '同意並繼續',
  'order.AfterWeChatAuthorizationYouCanEnterTheAccessRequestingAuthorization':
    '微信授權後可進入訪問，請求授權中···',
  'order.TheSystemIsOutOfOrder': '系統開小差啦',
  'order.TheSystemIsDesertedPleaseTryAgainLater': '系統開小差啦，請稍後再試',
  'order.PaymentFailed': '支付失敗!',
  'order.paymentSuccessful': '支付成功',
  'order.SuccessfullyPaidJumpingIn': '已支付成功，正在跳轉中...',
  'order.WeChat': '微信',
  'order.HuabeiInstallment': '花唄分期',
  'order.AlipayScanCodePayment': '支付寶掃碼支付',
  'order.ScanCodePayment': '掃碼付',
  'order.QueryFailedPleaseTryAgain': '查詢失敗請重試',
  'order.ThePaymentIsSuccessfulPleaseReturnToWeChatToContinueTheOperation':
    '支付成功，請返回微信繼續操作',
  'order.MallCashierPagePaymentConfirmationPopup': '商城收銀台頁_支付確認彈窗',
  'order.ParameterError': '參數錯誤!',
  'order.NoPaymentResultDetected': '沒有檢測到支付結果',
  'order.IfYouHaveAlreadyPaidPleaseClickRefreshToQueryTheResults':
    '若已經支付 請點擊刷新進行結果查詢',
  'order.payAgain': '重新支付',
  'order.MallCashierPagepaymentConfirmationPopupconfirmationButton':
    '商城收銀台頁_支付確認彈窗_確認按鈕',
  'order.refresh': '刷新',
  'order.MallCashierPagePaymentConfirmationPopupCloseButton': '商城收銀台頁_支付確認彈窗_關閉按鈕',
  'order.Minute': '分',
  'order.Expect': '期',
  'order.0HandlingFee': '0手續費',
  'order.IncludingHandlingFee': '含手續費￥',
  'order.perIssue': '/每期',
  'order.recommend': '推薦',
  'order.PleaseConfirmThatYouHaveReadAndAgree': '請確認您已閱讀並同意',
  'order.UserServicesAgreement': '《用戶服務協議》',
  'order.AfterPayingYouNeedToComeBackToConfirmThePaymentResultToEnsureTheSmoothDistributionOfThePurchasedContent':
    '支付後需要回來確認支付結果，確保購買內容順利發放！',
  'order.PaymentAmount': '支付金額',
  'order.readAndAgree': '已閱讀並同意',
  'order.AreYouSureYouWantToForgoPayment': '您確定要放棄支付嗎？'
};
